import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Actions = styled.div`
  margin-top: 32px;
`;
